import { render, staticRenderFns } from "./CombineMeasuresDropdown.vue?vue&type=template&id=487729aa&scoped=true&"
import script from "./CombineMeasuresDropdown.vue?vue&type=script&lang=js&"
export * from "./CombineMeasuresDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CombineMeasuresDropdown.vue?vue&type=style&index=0&id=487729aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487729aa",
  null
  
)

export default component.exports